import styled from 'styled-components';
import { StyledDynamicIssueTypes } from './DynamicIssueTypes.style';
import { LineSkeleton } from 'components/base/Skeletons';
import { StyledMenuItemWrapper } from 'components/base/MultiLevelDropdown/components/ListItemRenderer.style';

const StyledLoader = styled(StyledDynamicIssueTypes)`
  padding: 1rem 0;
`;

const LOADING_LINES_COUNT = 3;

const Loader = () => {
  return (
    <StyledLoader>
      {Array.from({ length: LOADING_LINES_COUNT }, (_, index) => (
        <StyledMenuItemWrapper key={index}>
          <LineSkeleton size={90} />
        </StyledMenuItemWrapper>
      ))}
    </StyledLoader>
  );
};

export default Loader;
